import userPopoverContent from './userPopoverContent';

export default userPopoverContent;
